import { useNav } from "./useNav";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { watch, onBeforeMount, type Ref } from "vue";

export function useTranslationLang(ref?: Ref) {
  const { $storage, changeTitle, handleResize } = useNav();
  const { locale, t } = useI18n();
  const route = useRoute();

  const switchLang = (langKey = "zh-CN", reload = true) => {
    $storage.locale = { locale: langKey };
    locale.value = langKey;
    ref && handleResize(ref.value);
    if (reload) {
      setTimeout(() => {
        location.reload();
      }, 10);
    }
  };

  watch(
    () => locale.value,
    () => {
      changeTitle(route.meta);
    }
  );

  onBeforeMount(() => {
    locale.value = $storage.locale?.locale ?? "zh-CN";
  });

  return {
    t,
    route,
    locale,
    switchLang
  };
}
